import { filtersHelper } from '@/utils';
import { groupModel } from '@/models/api/group.model';
import { officeModel } from '@/models/api/office.model';
import { companyTypeModel } from '@/models/api/companyType.model';
import { departmentModel } from '@/models/api/department.model';

export const companyModel = (data) => ({
    ...companyFormat(data),
    group: data.group ? groupModel(data.group) : null,
    companyType: data.company_type ? companyTypeModel(data.company_type) : null,
    parentCompany: data.parent_company ? companyFormat(data.parent_company) : null,
    childCompanies: (data.child_companies ?? []).map((item) => companyFormat({ data: item })),
    offices: (data.offices ?? []).map((item) => officeModel(item)),
    departments: (data.departments ?? []).map((item) => departmentModel(item)),
    companyServices: (data.company_services ?? []).map((item) => item),
});

function companyFormat (data) {
    return {
        uuid: data.uuid,
        name: data.name,
        displayName: data.display_name,
        logoUrl: data.logo_url,
        description: data.description,
        intro: data.intro,
        stockCode: data.stock_code,
        colorCode: data.color_code,
        websiteUrl: data.website_url,
        email: data.email,
        phoneCode: data.phone_code,
        phoneIso: data.phone_iso,
        phoneNumber: data.phone_number,
        isListed: data.is_listed,
        isActive: data.is_active,
        createdAt: filtersHelper.getDateFormat(data.created_at),
        createdBy: data.created_by,
        updatedAt: filtersHelper.getDateFormat(data.updated_at),
        updatedBy: data.updated_by,
        deletedAt: filtersHelper.getDateFormat(data.deleted_at),
        deletedBy: data.deleted_by,
    };
}